module.exports = __webpack_public_path__ + "img/avatar5.df672100.png";